export default __webpack_public_path__ + "static/media/gnd_en_rudl_a2.4ffa5295.mp3";